import loadable from '@loadable/component';
import { OverlaySpinner } from '@ankr.com/ui';

import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Page } from 'modules/layout/components/Page';
import { Placeholder } from 'modules/common/components/Placeholder';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAuth } from 'modules/auth/hooks/useAuth';

const OAuthPage = loadable(
  async () => {
    const module = await import('./OAuthPage');

    return module.OAuthPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

export const OAuthPageContainer = () => {
  const { authToken, isLoggedIn, isLoggingIn } = useAuth();
  const { isAccountInitializing } = useAccount();

  const hasAuthToken = Boolean(authToken);
  const shouldLogIn = hasAuthToken && !isLoggedIn;

  return (
    <Page>
      <NoSSRGuard>
        <Placeholder
          hasPlaceholder={isLoggingIn || shouldLogIn || isAccountInitializing}
          placeholder={<OverlaySpinner />}
        >
          <OAuthPage />
        </Placeholder>
      </NoSSRGuard>
    </Page>
  );
};
